import { render, staticRenderFns } from "./allotinTask.vue?vue&type=template&id=a75ec336&scoped=true"
import script from "./allotinTask.vue?vue&type=script&lang=js"
export * from "./allotinTask.vue?vue&type=script&lang=js"
import style0 from "./allotinTask.vue?vue&type=style&index=0&id=a75ec336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75ec336",
  null
  
)

export default component.exports